module.exports = __webpack_public_path__ + "img/507.9fe8fcb0.png";